"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateItemMasterSchema = exports.createItemMasterSchema = exports.itemMasterShape = void 0;
const zod_1 = require("zod");
exports.itemMasterShape = {
    itemCode: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(255),
    categoryId: zod_1.z.string().uuid().optional(),
    unitId: zod_1.z.string().uuid().optional(),
    reorderLevel: zod_1.z.number().int().nonnegative().optional(),
    isAsset: zod_1.z.boolean().default(false),
};
exports.createItemMasterSchema = zod_1.z.object(exports.itemMasterShape);
exports.updateItemMasterSchema = exports.createItemMasterSchema.partial();
//# sourceMappingURL=item-master.schema.js.map